// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"loader_loader_container__3O9pQ","lds_spinner":"loader_lds_spinner__1zgn5","lds-spinner":"loader_lds-spinner__18-VU"};